import { apiGetNextOrderDates, apiUpdateCadence } from "Root/api/apiProfile";
import toastService from "Root/profile/toastService";
import { setGlobalLoading, setNextCadence, setNextOrderData } from "../../actionCreators/makeActionCreator";
export const LoadNextOrderDatesThunk = () => async (dispatch) => {
    try {
        const data = await apiGetNextOrderDates();
        dispatch(setNextOrderData(data));
    }
    catch (error) {
        toastService.errorMessage(error);
    }
};
export const UpdateCadenceThunk = (weeks, plan) => async (dispatch) => {
    try {
        dispatch(setGlobalLoading(true));
        const data = await apiUpdateCadence({ weeks, plan });
        dispatch(setNextCadence(data));
        dispatch(setGlobalLoading(false));
        toastService.successMessage("Success! Your subscription frequency has been updated.");
        const nextOrderData = await apiGetNextOrderDates();
        dispatch(setNextOrderData(nextOrderData));
    }
    catch (error) {
        toastService.errorMessage(error);
    }
};
